import { render } from "./n-switch.vue?vue&type=template&id=ce7d6e62&scoped=true&ts=true"
import script from "./n-switch.vue?vue&type=script&lang=ts"
export * from "./n-switch.vue?vue&type=script&lang=ts"

import "./n-switch.vue?vue&type=style&index=0&id=ce7d6e62&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce7d6e62"]])

export default __exports__